import { defineMessages } from 'react-intl';

export default defineMessages({
	description: {
		id: 'pages.walletPayment.manualBarcode.description',
		defaultMessage: 'با تفنگی بارکد را اسکن کنید یا دستی کد را وارد کنید.',
	},
	title: {
		id: 'pages.walletPayment.manualBarcode.title',
		defaultMessage: 'بارکد محصول',
	},
	buttonLabel: {
		id: 'pages.walletPayment.manualBarcode.buttonLabel',
		defaultMessage: 'مرحله بعد',
	},
	amount: {
		id: 'pages.walletPayment.manualBarcode.amount',
		defaultMessage: 'مبلغ نهایی:',
	},
});
